import { Theme } from './';

export default (theme: Theme) => ({
    textTransform: 'uppercase',
    fontFamily: theme.typography.fontFamily.sansSerif,
    fontWeight: theme.typography.fontWeight.bold,
    color: theme.color.gray70,
    fontSize: '1.3rem',
});

export const revertFilterLabelStyles = (theme: Theme) => ({
    textTransform: 'none',
    fontFamily: theme.typography.fontFamily.sansSerif,
    // fontWeight: theme.typography.fontWeight.bold,
    color: theme.color.gray70,
    fontSize: '1.3rem',
    paddingBottom: 4,
    opacity: 1,
    '> *': {
        fontWeight: theme.typography.fontWeight.bold,
    },
});
